export default __webpack_public_path__ + "static/media/left-example.e968555b.png";